export default __webpack_public_path__ + "static/financial_report_2023-ac4c0568b1bb2229c10ab6a9809170a3.pdf";